import axiosInstance from "../../utils/axiosconfig";

const getGoldSchemes = async () => {
  const response = await axiosInstance.get("gold-scheme");
  return response.data;
};

const getGoldScheme = async (id) => {
  const response = await axiosInstance.get(`gold-scheme/${id}`);
  return response.data;
};

const createGoldScheme = async (data) => {
  const response = await axiosInstance.post("gold-scheme", data);
  return response.data;
};

const updateGoldScheme = async ({ id, schemeData }) => {
  const response = await axiosInstance.put(`gold-scheme/${id}`, schemeData);
  return response.data;
};

const deleteGoldScheme = async (id) => {
  const response = await axiosInstance.delete(`gold-scheme/${id}`);
  return response.data;
};

const getSchemeNames = async () => {
  const response = await axiosInstance.get("settings/scheme-names");
  return response.data;
};

const updateSchemeNames = async (names) => {
  const response = await axiosInstance.put("settings/scheme-names", { names });
  return response.data;
};

const goldSchemeService = {
  getGoldSchemes,
  getGoldScheme,
  createGoldScheme,
  updateGoldScheme,
  deleteGoldScheme,
  getSchemeNames,
  updateSchemeNames,
};

export default goldSchemeService;
